import { render, staticRenderFns } from "./FilterSuggestion.vue?vue&type=template&id=71bf9f7c&scoped=true&"
import script from "./FilterSuggestion.vue?vue&type=script&lang=js&"
export * from "./FilterSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./FilterSuggestion.vue?vue&type=style&index=0&id=71bf9f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf9f7c",
  null
  
)

export default component.exports